import Form from 'cerebral-module-forms/Form'

function preparePasswordFields({ state }) {
  let { remoteLogin } = state.get('client')
  let passwords = {
    password: {
      value: '',
      type: 'password',
      validations: ['equalsField:"confirmPassword"', 'passwordRule'],
      dependsOn: 'client.registrating.current.newPassword.confirmPassword',
      errorMessages: [
        { key: 'bus-client.errors.confirmPassword' },
        { key: 'bus-client.errors.passwordRule' }
      ],
      client: true,
      isRequired: !remoteLogin
    },
    confirmPassword: {
      value: '',
      type: 'password',
      validations: ['equalsField:"password"', 'passwordRule'],
      errorMessages: [
        { key: 'bus-client.errors.confirmPassword' },
        { key: 'bus-client.errors.passwordRule' }
      ],
      dependsOn: 'client.registrating.current.newPassword.password',
      client: true,
      isRequired: !remoteLogin
    }
  }

  state.set('client.registrating.current.newPassword', Form(passwords))
}

export default preparePasswordFields



// WEBPACK FOOTER //
// ./src/modules/app/actions/preparePasswordFields.js